import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-56f46c25"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "step-2-container" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "step-2-explainer" }, " Statements and Invoices can now be printed and emailed: ", -1))
const _hoisted_3 = { class: "row-fields-2" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Print a copy of each Statement for your own files", -1))
const _hoisted_5 = { class: "controls-row" }
const _hoisted_6 = { class: "row-fields-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Print a copy of each Statement to post", -1))
const _hoisted_8 = { class: "controls-row" }
const _hoisted_9 = { class: "row-fields-2" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Produces Emails and attaches Statements as a PDF", -1))
const _hoisted_11 = { class: "controls-row" }
const _hoisted_12 = { class: "row-fields-2" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "View the Payment Export file", -1))
const _hoisted_14 = { class: "controls-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { PropType, ref, watch } from "vue";
import DxButton from "devextreme-vue/button";
import AcquaintInfoBox from "@/components/ui/inputs/acquaint-info-box.vue";
import SwitchToggle from "@/components/ui/toggles/switch-toggle.vue";
import SummaryCustomPanel from "@/components/financials/summary-custom-panel.vue";
import { useFinancialHelper } from "@/utils/financials/useFinancialHelper";
import EmailFormModal from "@/components/email/email-form-modal.vue";
import { Templates } from "@/enums/constants/Templates";
import {
  BulkStatementRequest,
  ConsolidatedPaymentFormItem,
} from "@/types/financials/ConsolidatedPayment";
import { useUserHelper } from "@/utils/users/useUserHelper";
import { useAccountHelper } from "@/utils/accounts/useAccountHelper";


export default /*#__PURE__*/_defineComponent({
  __name: 'consolidated-payment-step2',
  props: {
  /**
   * Form data object containing ConsolidatedPaymentFormItem details.
   * @type {ConsolidatedPaymentFormItem}
   * @required true
   */
  formItem: {
    type: Object as PropType<ConsolidatedPaymentFormItem>,
    required: true,
  },
  /**
   * Array of contact IDs for filtering or selection purposes.
   * @type {number[]}
   * @required true
   */
  contactIds: {
    type: Array as PropType<number[]>,
    required: false,
  },
},
  emits: [
  /**
   * Emits the updated formItem to the parent component
   * @event update:formItem
   */
  "update:formItem",
],
  setup(__props, { emit }) {

const props = __props;





const accountHelper = useAccountHelper();
const userHelper = useUserHelper();
const financialHelper = useFinancialHelper();
const displayEmailFormModal = ref(false);
const pdfRequest = ref<BulkStatementRequest>();
const localFormItem = ref<ConsolidatedPaymentFormItem>({ ...props.formItem });
const companyId = ref(0);

watch(
  () => props.formItem,
  (newVal) => {
    localFormItem.value = { ...newVal };
  },
  { deep: true },
);

const onPrintFiling = async () => {
  await previewStatements(true);
};

const onPrintPosting = async () => {
  await previewStatements(false);
};

const onEmailProducing = async () => {
  companyId.value = await accountHelper.readBankAccountCompany(
    localFormItem.value.bankAccountId,
  );
  pdfRequest.value = {
    bankAccountId: localFormItem.value.bankAccountId,
    allForFilling: true,
    usePreferredDeliveryMethod: localFormItem.value.preferredDeliveryMethod,
    accountStatments: localFormItem.value.accountStatements,
  };
  displayEmailFormModal.value = true;
};

const previewStatements = async (booAllForFiling: boolean) => {
  const request: BulkStatementRequest = {
    bankAccountId: localFormItem.value.bankAccountId,
    allForFilling: booAllForFiling,
    usePreferredDeliveryMethod: localFormItem.value.preferredDeliveryMethod,
    accountStatments: localFormItem.value.accountStatements,
  };

  const pdf = await financialHelper.produceConsolidatedStatements(request);

  if (!pdf) {
    return;
  }

  // Create url
  const url = window.URL.createObjectURL(pdf);

  // Link allows us to download the pdf
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `consolidated-payment-run-summary-statment-${Date.now()}.pdf`,
  );
  document.body.appendChild(link);
  link.click();

  // Clears memory
  link.remove();
  window.URL.revokeObjectURL(url);
};

const onViewStatementsFile = async () => {
  try {
    const file = await financialHelper.fetchPaymentRunFile(
      localFormItem.value.paymentRunExportFileName,
    );

    if (!file) {
      return;
    }

    // Create URL and trigger download
    const url = window.URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = url;
    link.download = `consolidated-payment-run-credits-${Date.now()}.csv`;

    // Append to body, click, and cleanup
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    return;
  }
};

const onPreferredDeliveryMethodChange = (value: boolean) => {
  localFormItem.value.preferredDeliveryMethod = value;
  emit("update:formItem", localFormItem.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", null, [
        _createVNode(SwitchToggle, {
          label: "Use Contacts Preferred Delivery Method i.e. Email/Post/Both",
          modelValue: localFormItem.value.preferredDeliveryMethod,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((localFormItem.value.preferredDeliveryMethod) = $event)),
            onPreferredDeliveryMethodChange
          ],
          "read-only": !localFormItem.value.enablePreferredDeliveryMethod
        }, null, 8, ["modelValue", "read-only"])
      ]),
      _createVNode(SummaryCustomPanel, {
        title: "Preview / Print for Filing",
        icon: "fa-regular fa-print"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("div", _hoisted_5, [
              _createVNode(AcquaintInfoBox, {
                text: localFormItem.value.statementsFiling.toString()
              }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                text: 'Preview / Print',
                type: 
              !localFormItem.value.enableButPrintForFiling ? 'normal' : 'default'
            ,
                "styling-mode": "contained",
                disabled: !localFormItem.value.enableButPrintForFiling,
                onClick: onPrintFiling
              }, null, 8, ["type", "disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SummaryCustomPanel, {
        title: "Preview / Print for Posting",
        icon: "fa-regular fa-envelope"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
              _createVNode(AcquaintInfoBox, {
                text: localFormItem.value.statementsPosting.toString()
              }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                text: 'Preview / Print',
                type: 
              !localFormItem.value.enableButPrintForPosting ? 'normal' : 'default'
            ,
                "styling-mode": "contained",
                disabled: !localFormItem.value.enableButPrintForPosting,
                onClick: onPrintPosting
              }, null, 8, ["type", "disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SummaryCustomPanel, {
        title: "Email",
        icon: "fa-regular fa-at"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createVNode(AcquaintInfoBox, {
                text: localFormItem.value.statementsEmail.toString()
              }, null, 8, ["text"]),
              _createVNode(_unref(DxButton), {
                text: 'Email',
                type: !localFormItem.value.enableButEmail ? 'normal' : 'default',
                "styling-mode": "contained",
                disabled: !localFormItem.value.enableButEmail,
                onClick: onEmailProducing
              }, null, 8, ["type", "disabled"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(SummaryCustomPanel, {
        title: "Payment Export File",
        icon: "fa-regular fa-file"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _createVNode(_unref(DxButton), {
                text: 'View',
                type: 
              !localFormItem.value.enableButPaymentExportFile ? 'normal' : 'default'
            ,
                "styling-mode": "contained",
                disabled: !localFormItem.value.enableButPaymentExportFile,
                onClick: onViewStatementsFile
              }, null, 8, ["type", "disabled"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _createVNode(EmailFormModal, {
      modelValue: displayEmailFormModal.value,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((displayEmailFormModal).value = $event)),
      emailTemplateId: _unref(Templates).ContractortStatementEmail,
      userId: _unref(userHelper).currentUserDetails.value?.id,
      contactList: __props.contactIds,
      consolidatedPaymentRequest: pdfRequest.value,
      companyId: companyId.value
    }, null, 8, ["modelValue", "emailTemplateId", "userId", "contactList", "consolidatedPaymentRequest", "companyId"])
  ], 64))
}
}

})